export const isAcceptedExtension = (extension) => {
  const validExtensions = [
    'doc',
    'docx',
    'docm',
    'odt',
    'ott',
    'fodt',
    'xls',
    'xlsx',
    'xlsm',
    'xlsb',
    'xlam',
    'ods',
    'ots',
    'fods',
    'ppt',
    'pptx',
    'pptm',
    'ppam',
    'ppsx',
    'ppsm',
    'sldx',
    'sldm',
    'pdf',
    'png',
    'jpg',
    'jpeg',
    'tif',
    'tiff',
    'odi',
    'asf',
    'vfw',
    'avi',
    'mp4',
    'mpg4',
    'm4v',
    'mov',
    'mpg',
    'mpeg',
    'mpe',
    'm75',
    'm15',
    'm2v',
    'ts',
    'qt',
    'div',
    'wmv',
    'mkv',
    'zip',
    'rar',
    '7z',
    'txt',
    'ott',
  ];

  return validExtensions.includes(extension.toLowerCase());
};

export const getImageDimensions = (file: File): Promise<{ width: number; height: number }> =>
  new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve({ width: img.naturalWidth, height: img.naturalHeight });
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('Lecture image impossible'));
    };
    img.src = url;
  });

export default isAcceptedExtension;
